module.exports = __webpack_public_path__ + "hands.a1c5ffec80f0e9fd098f2e1a8a437d95.png";